import {UmpireImage} from '../umpire-image';
import {UmpireComponent} from '../umpire-component';
import {UmpirePublicationCategory} from '../umpire-publication-category';
import {UmpireVenue} from '../umpire-venue';
import {UmpireComponentType} from '../umpire-component-type';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireVisibilityOption} from '../umpire-visibility-options';
import {Language} from '../umpire-language-service';

export class UmpireArticle implements UmpirePublicationOptions {
  author!: string | null;

  components!: Partial<UmpireComponent<UmpireComponentType>>[];

  header!: string | null;

  id!: string;

  image!: Partial<UmpireImage>;

  publication_category!: Partial<UmpirePublicationCategory>;

  relationshipNames!: string[];

  title!: string;

  type = 'article' as const;

  kind: 'standard' | 'event' | 'match' | 'static' = 'standard';

  visibility!: UmpireVisibilityOption[];

  client_id = '1';

  is_featured!: boolean;

  signed_in_only!: boolean;

  venue!: UmpireVenue;

  location!: {
    name: string;
    address: string;
  } | null;

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  slug!: string | null;

  preview_url!: string;

  available_translations!: Language[];

  locale!: Language;
}
